import "reflect-metadata";
import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import axios from "./axios";
import AxiosPlugin from "./plugins/axios";
import Vuelidate from "vuelidate";
import { Component } from "vue-property-decorator";
import "@/components";
import "@/filters";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/variables.scss";
import "./assets/style.scss";

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
    config: { id: "G-LB2NGT87M0" },
});

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(AxiosPlugin, axios);

Component.registerHooks(["validations"]);
Vue.use(Vuelidate);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount("#app");
